import React, { FC, useContext } from 'react';

import classNames from 'classnames';

import { Checkbox } from '@shared/ui';

import cls from './FilterSubBody.module.css';
import { FilSubContext } from '../FilterSub';

export const FilterSubBodyItem = ({ title, guid }) => {
    const { activeSubs, setActiveSubs } = useContext(FilSubContext);

    const guidList = activeSubs.map((sub) => sub.guid);

    const onCheckBoxChange = () => {
        if (guid === 'all') {
            setActiveSubs([
                {
                    guid: 'all',
                    title: i18next.t('FilterSubBodyItem.onCheckBoxChange.title')
                }
            ]);
        } else {
            const newList = activeSubs.filter((item) => item.guid !== 'all');
            setActiveSubs(newList);

            if (guidList.includes(guid)) {
                const newList = activeSubs.filter((item) => item.guid !== guid);
                setActiveSubs(newList);
                if (newList.length === 0) {
                    setActiveSubs([
                        {
                            guid: 'all',
                            title: i18next.t('FilterSubBodyItem.onCheckBoxChange.title')
                        }
                    ]);
                }
            } else {
                setActiveSubs((prev) => [...prev, { guid, title }]);
            }
        }
    };
    const isActiveSub = guidList.includes(guid);

    return (
        <div
            onClick={onCheckBoxChange}
            className={classNames(cls.filterSubBodyItem, { [cls.active]: guidList.includes(guid) })}
        >
            <Checkbox title={''} isActive={isActiveSub} onClick={() => {}} />
            <span>{title}</span>
        </div>
    );
};
